/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'react-simple-tooltip';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import axios from 'axios';

import { TEXT } from '../../locals';
import GoogleIcon from '../../icons/google.svg';
import FacebookIcon from '../../icons/facebook.svg';
import KEYS from '../../keys';
import { API } from '../../api';
import { URL } from '../../url';
import { ERROR_MESSAGES } from '../../error_messages';
import { setToken, Push } from '../../util';

import '../../styles/socialLogin.scss';

const { SOCIAL } = TEXT;
const { GOOGLE_CLIENT_ID, FACEBOOK_APP_ID } = KEYS;

class SocialLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onGoogleLoginSuccess = ({ accessToken }) => {
    this.login(API.googleAuth, accessToken);
  }

  onGoogleLoginFailure = () => {
    const { setError } = this.props;
    setError('Oops, Try Again');
  }

  onFacebookLoginSuccess = ({ accessToken }) => {
    this.login(API.facebookAuth, accessToken);
  }

  login= (url, access_token) => {
    const { setError, role, closeAllSidebars } = this.props;
    if (access_token) {
      const data = {
        access_token,
        roles: [role],
      };
      axios({
        method: 'post',
        url,
        data,
      })
        .then((res) => {
          const { token } = res.data;
          if (token) {
            closeAllSidebars();
            setToken(token);
            Push(URL.auth + token);
          } else {
            setError(ERROR_MESSAGES.TRY_AGAIN);
          }
        })
        .catch((err) => {
          const { data: resData } = err.response || {};
          const { type } = resData || {};
          setError(ERROR_MESSAGES[type] || ERROR_MESSAGES.TRY_AGAIN);
        });
    } else {
      setError(ERROR_MESSAGES.TRY_AGAIN);
    }
  }

  render() {
    const { signUp } = this.props;
    const SOCIAL_TEXT = signUp ? SOCIAL.SIGN_UP : SOCIAL.LOGIN;
    return (
      <div className="social_login">
        <GoogleLogin
          clientId={GOOGLE_CLIENT_ID}
          render={renderProps => (
            <div className="google" onClick={renderProps.onClick}>
              <div className="google_icon">
                <GoogleIcon />
              </div>
              <div className="google_text">
                {SOCIAL_TEXT.GOOGLE_TEXT}
              </div>
            </div>
          )}
          buttonText="Login"
          onSuccess={this.onGoogleLoginSuccess}
          onFailure={this.onGoogleLoginFailure}
          cookiePolicy="single_host_origin"
        />
        <Tooltip
          content={SOCIAL_TEXT.FACEBOOK_TEXT}
          className="tooltip"
          arrow={10}
        >
          <FacebookLogin
            appId={FACEBOOK_APP_ID}
            callback={this.onFacebookLoginSuccess}
            render={renderProps => (
              <div className="facebook" onClick={renderProps.onClick}>
                <div className="facebook_icon">
                  <FacebookIcon />
                </div>
              </div>
            )}
          />
        </Tooltip>

      </div>
    );
  }
}

SocialLogin.propTypes = {
  signUp: PropTypes.bool,
  setError: PropTypes.func.isRequired,
  closeAllSidebars: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

SocialLogin.defaultProps = {
  signUp: false,
};

export default SocialLogin;
